import { render, staticRenderFns } from "./hero-section.vue?vue&type=template&id=4765a24f&"
import script from "./hero-section.vue?vue&type=script&lang=js&"
export * from "./hero-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports